import React, { useEffect } from 'react';
import { RBHBox, RBHButton, RBHSelect, RBHTable, RBHText } from '../../../../shared/components';
import branchStyles from '../styles';
import styles from './styles';
import { Breadcrumb, Select, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import styleText from '../../../../shared/components/rbh-text/styles';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { mainCreators } from '../../../main-action';
import { MAIN_STATE_KEY } from '../../../main-reducer';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { BRANCH_STATE_KEY, branchStateSelector } from '../redux/branch-reducer';
import metrics from '../../../../shared/theme/metrics';
import styleButton from '../../../../shared/components/rbh-button/styles';
import { httpCreators } from 'rbh-merchant-core';
import { BRANCH_REQUEST_ID_LIST } from '../redux/branch-constant';
import { branchSagas } from '../redux/branch-saga';
import { BranchService } from '../redux/branch-service';
import { branchCreators } from '../redux/branch-action';

export const BranchMappingScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const branchData = useSelector(branchStateSelector(BRANCH_STATE_KEY.BRANCH_LIST)) as [];
  const vatAddressData = useSelector(branchStateSelector(BRANCH_STATE_KEY.VAT_LIST)) as [];
  const defaultMapping = useSelector(branchStateSelector(BRANCH_STATE_KEY.MAPPING_LIST)) as [];

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 1));
    if (branchData.length === 0 || vatAddressData.length === 0) {
      pushToBranch();
    }
  }, []);

  const pushToMain = () => {
    history.push('/main');
  };

  const pushToBranch = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/branchmanagement');
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid='id-breadcrumb-to-home' id='id-breadcrumb-to-home' style={styleText.breadCrumbItemLink}
              onClick={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true,
                  onOk: pushToMain,
                  type: MODAL_TYPE.CONFIRM_EDIT
                }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid='id-breadcrumb-to-branch' id='id-breadcrumb-to-branch' style={styleText.breadCrumbItemLink}
              onClick={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true,
                  onOk: pushToBranch,
                  type: MODAL_TYPE.CONFIRM_EDIT
                }))}>
              <FormattedMessage id={'main.branchmanagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid='id-breadcrumb-branchmapping' id='id-breadcrumb-branchmapping'
              style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.branchmapping'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const getVatAddressText = (vat: any) => {
    return (vat.vatAddressProvince === 'กรุงเทพมหานคร' ?
      vat.vatAddressBranchNo + ' - ' + vat.vatAddressDetail + ' แขวง' + vat.vatAddressSubdistrict + ' เขต' + vat.vatAddressDistrict + ' ' +
      vat.vatAddressProvince + ' ' + vat.vatAddressPostalCode
      : vat.vatAddressBranchNo + ' - ' + vat.vatAddressDetail + ' ตำบล' + vat.vatAddressSubdistrict + ' อำเภอ' + vat.vatAddressDistrict + ' จังหวัด' +
      vat.vatAddressProvince + ' ' + vat.vatAddressPostalCode);
  };

  const getShopAddressText = (address: any) => {
    return (address.addressProvince === 'กรุงเทพมหานคร' ?
      address.addressDetail + ' แขวง' + address.addressSubdistrict + ' เขต' + address.addressDistrict + ' ' +
      address.addressProvince + ' ' + address.addressPostalCode
      : address.addressDetail + ' ตำบล' + address.addressSubdistrict + ' อำเภอ' + address.addressDistrict + ' จังหวัด' +
      address.addressProvince + ' ' + address.addressPostalCode);
  };

  const { Option } = Select;
  const getVatAddressOption = () => {
    if (vatAddressData && vatAddressData.length > 0) {
      return vatAddressData.map((vat: any, index) => {
        const text = getVatAddressText(vat);
        return (
          <Option style={styleText.formText} id={`vatAddressOption-${index}`} key={index}
            data-testid={`vatAddressOption-${index}`} value={vat.vatAddressId} title={text}>{text}</Option>);
      });
    }
    return null;
  };

  const onSelectedVatAddress = (vatId: number, index: number) => {
    if (defaultMapping) {
      defaultMapping.map((mapping: any, i) => {
        if (i === index) {
          mapping.vatAddressId = vatId;
        }
      });
    }
  };

  const mappingFail = () => {
    dispatch(branchCreators.setBranchState(BRANCH_STATE_KEY.ALERT_FAIL, true));
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: false,
      type: MODAL_TYPE.ERROR
    }));
  };

  const onClickSave = () => {
    const data = { mappingLists: defaultMapping };
    dispatch(httpCreators.request({
      id: BRANCH_REQUEST_ID_LIST.MAPPING_BRANCH_VAT,
      sagaHandler: branchSagas.mappingBranchVatHandler as any,
      callbackParams: { pushToBranch, mappingFail },
      service: BranchService.mappingBranchVat,
      serviceParams: data
    }));
  };

  const columns = [
    {
      width: metrics.tableHeader.width180,
      title: <FormattedMessage id={'main.branchmapping.column1'} />,
      render: (value: any, all: any, index: number) => {
        const shopName = 'shopName-' + index;
        const shopBranchCode = 'branchCode-' + index;
        const shopAddress = 'shopAddress-' + index;
        return (<RBHBox id={`shops-${index}`} style={{ width: metrics.tableHeader.width400 }}>
          <RBHBox style={{ width: metrics.tableHeader.width400 }} key={index}>
            <RBHText id={shopName} data-testid={shopName} style={styleText.textMediumFakeBlack}>
              {all.shopName}
            </RBHText>
            <RBHText id={shopBranchCode} data-testid={shopBranchCode} style={styleText.textRegularGray}>
              {all.branchCode}
            </RBHText>
            <RBHText id={shopAddress} data-testid={shopAddress} style={styleText.textRegularFakeBlack}>
              {getShopAddressText(all.address)}
            </RBHText>
          </RBHBox>
        </RBHBox>);
      }
    },
    {
      width: metrics.tableHeader.width180,
      title: <FormattedMessage id={'main.branchmapping.column2'} />,
      render: (value: any, all: any, index: number) => {
        const vatAddress = 'vatAddressId-' + index;
        const vatAddressSelect = 'vatAddressSelect-' + index;
        return (<RBHBox id={vatAddress} style={{ width: metrics.tableHeader.width420 }}>
          <RBHText style={styleText.formText}>
            <RBHSelect
              style={{ width: metrics.tableHeader.width420 }}
              data-testid={vatAddressSelect}
              id={vatAddressSelect}
              // @ts-ignore
              defaultValue={all.vatAddressId ? all.vatAddressId : vatAddressData[0]?.vatAddressId}
              onSelect={(vatId: number) => onSelectedVatAddress(vatId, index)}>
              {getVatAddressOption()}
            </RBHSelect>
          </RBHText>
        </RBHBox>
        );
      }
    }
  ];

  return (
    <RBHBox>
      {BreadcrumbRender()}
      <RBHBox>
        <RBHBox style={branchStyles.header}>
          <RBHText data-testid='id-text-branchmapping' id='id-text-branchmapping' style={styleText.headerText}
            text={'main.branchmapping'} />
        </RBHBox>
        <RBHBox style={styles.defaultContent}>
          <RBHTable columns={columns}
            dataSource={branchData}
            scroll={{ y: 370 }}
            rowKey={'vatAddressId'}
            pagination={false} />
        </RBHBox>
        <RBHBox style={styles.boxButton}>
          <Space size={'middle'}>
            <RBHButton id='branchmapping-button-cancel' style={styleButton.buttonFromCancelGradient} type='primary'
              htmlType='button' text='main.button_cancel'
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onOk: pushToBranch,
                type: MODAL_TYPE.CONFIRM_EDIT
              }))} data-testid={'branchmapping-button-cancel'} />
            <RBHButton id={'branchmapping-button-confirm'} style={styleButton.buttonFromConfirmGradient} type='primary'
              htmlType='submit' text={'main.branchform.save'} onClick={onClickSave} data-testid={'branchmapping-button-confirm'} />
          </Space>
        </RBHBox>
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
